<ul *ngIf="1 < totalPages" class="pagination">
  <li class="page-item" [ngClass]="{ disabled: 1 == pageNumber }">
    <a id='paginationPrevious' class="page-link" (click)="goToPage(1)" aria-label="Previous">
      <span aria-hidden="true">&laquo;</span> <span class="sr-only">Previous</span>
    </a>
  </li>
  <li class="page-item" *ngFor="let i of pageItems" [ngClass]="{ active: i == pageNumber }">
    <a class="page-link" (click)="goToPage(i)">{{ i }}</a>
  </li>
  <li class="page-item" [ngClass]="{ disabled: pageNumber == totalPages }">
    <a id='paginationNext' class="page-link" (click)="goToPage(totalPages)" aria-label="Next">
      <span aria-hidden="true">&raquo;</span> <span class="sr-only">Next</span>
    </a>
  </li>
</ul>



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/core/pagination/pagination.component.html